import styled from 'styled-components';
import Button from '@cloudscape-design/components/button';

const SubmitButton = styled(Button)`
  background-color:rgb(31, 38, 51) !important;
  color: white !important;
  font-weight: bold;
  border-radius: 5px;
  &:hover {
    background-color:rgb(222, 217, 210) !important;
}

    display: flex;
    justify-content: flex-end; 
  &:disabled {
    background-color: #ccc !important;
    color: #888 !important;
    cursor: not-allowed !important;
  }
`



export default SubmitButton;
